export const countryCurrencyList = [
  // 中国
  {
    currencyName: "人民币",
    englishName: "Renminbi",
    unit: "元",
    symbol: "￥",
    code: "CN",
    currency: "CNY"
  },
  // 越南
  {
    currencyName: "越南盾",
    englishName: "Vietnamese Dong",
    symbol: "₫",
    code: "VN",
    currency: "VND"
  },
  // 泰国
  {
    currencyName: "泰铢",
    englishName: "Thai Baht",
    symbol: "฿",
    code: "TH",
    currency: "THB"
  },
  // 菲律宾
  {
    currencyName: "菲律宾比索",
    englishName: "Philippine Peso",
    symbol: "₱",
    code: "PH",
    currency: "PHP"
  },
  // 马来西亚
  {
    currencyName: "马来西亚令吉",
    englishName: "Malaysian Ringgit",
    alias: "马币",
    symbol: "RM",
    code: "MY",
    currency: "MYR"
  }
];
